import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ECheckModel } from '../../deposit/cashier-models/models';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';


@Component({
    selector: 'page-withdrawal-echeck-add',
    templateUrl: 'withdrawal-echeck-add.html',
})
export class WithdrawalECheckAddPage extends WithdrawalBaseComponent implements OnInit {
    @ViewChild('Content') content: IonContent;

    private error = null;
    
    private addAccountForm: FormGroup;

    private transitNumber: AbstractControl;
    private institutionNumber: AbstractControl;
    private accountNumber: AbstractControl;
    private accountType: AbstractControl;
    private bankName: AbstractControl;
    private ssn: AbstractControl;
    private payment_type_code: AbstractControl;
    public labels: DepositMainLabels;
    
    private accounts: any = [];

    @Input() ssnValue;
    @Input() navigateBackPage: string;

    constructor(
        // private logger: Logger,
        private withdrawService:WithdrawalService,
        private cashierContentProvider:CashierContentService,
        private navigator:Navigator,
        private cashierProvider: CashierService,
        public utils:UtilsService,
        private successMessageService: SuccessMessageService) {
        
        super();
        this.labels = new ECheckModel();

        this.successMessageService.clearMessage();
        this.error = null;
    }

    ngOnInit() {
        this.addAccountForm = new FormGroup(
            {
                transitNumber: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern('^[0-9]*')]),
                institutionNumber: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(3), Validators.pattern('^[0-9]*')]),
                accountNumber: new FormControl('', [Validators.required, Validators.maxLength(12), Validators.pattern('^[0-9]*')]),
                ssn: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern('^[0-9]*')]),
                accountType: new FormControl('PC', Validators.required),
                bankName: new FormControl(''),
            }
        )

        this.transitNumber = this.addAccountForm.get('transitNumber');
        this.institutionNumber = this.addAccountForm.get('institutionNumber');
        this.accountNumber = this.addAccountForm.get('accountNumber');
        this.ssn = this.addAccountForm.get('ssn');
        this.accountType = this.addAccountForm.get('accountType');
        this.bankName = this.addAccountForm.get('bankName');
        
        if (typeof this.ssnValue != 'undefined') {
            this.addAccountForm.controls['ssn'].setValue('XXX-XXX-' + this.ssnValue);
            this.addAccountForm.controls['ssn'].clearValidators();            
        }
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad WithdrawalECheckAddPage');
    }

    ionViewDidEnter(){
        this.cashierContentProvider
        .getPageConfig("echeck-add")
        .then((response: DepositMainLabels) => {
          this.labels = response;
        });
    }

    onAddAccount() {
        this.successMessageService.clearMessage();
        this.error = null;
        
        let addAccountFormObj: any = this.addAccountForm.value;

        addAccountFormObj.payment_type_code = "ACH";

        if(addAccountFormObj.ssn.length > 4) {
            addAccountFormObj.ssn = addAccountFormObj.ssn.substr(addAccountFormObj.ssn.length - 4)
        }

        this.cashierProvider.callAddAccount(addAccountFormObj).subscribe(
            (response: any) => {
                if (response && !!response.result ) {
                    if (response.payload != null) {
                        this.successMessageService.setMessage('Thank you, your e-check account was successfully added.');
                        this.addAccountForm.reset();
                        this.content.scrollToTop();
                    }
                }
            },
            (error) => {
                this.error = this.handleError(error);
                // this.logger.log("onAddAccount error = ", error);
                this.content.scrollToTop();
            }
        )

        this.error = null;
    }

    hasSin() {
        if (typeof this.ssnValue != 'undefined' && this.ssnValue != '') {
            return true;
        }
        return false;
    }

    onBack = () => {
        if (!!this.navigateBackPage) {
            this.navigator.navigateTo(this.navigateBackPage);
        } else {
            this.navigator.back();
        }
    }
    radioChangedCard(e){
        this.accountType = e.target.value;
    }
}